import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Image, Rating, TileListItem, useTileListContext } from '@as/cotopaxi';
import { useAemConfig } from '@as-react/common-components';
import { ProductImageSizesPortraitEnum, } from '@as-react/common-types';
import { determineSelectedSku, findColor, findSizeBySku, isOneSizeProduct } from '@as-react/common-utils';
import { CaretRightIcon } from '@yonderland/andes-icons';
import { Box, Breakpoint, PillButton, Price, Stack, useMediaQuery, useMediaQueryMatchesOnDesktop, TextAlpha, Icon, Link, } from '@yonderland/andes-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { PRODUCT_URL_PREFIX } from '../../constants/ProductConstants';
import { MAX_SCREEN_WIDTH_TABLET, MAX_SCREEN_WIDTH_TABLET_SMALL, MIN_SCREEN_WIDTH_DESKTOP_LARGE, MIN_SCREEN_WIDTH_TABLET, } from '../../constants/ScreenWidthConstants';
import { MiniPDPContainer } from '../../containers/MiniPDPContainer';
import { useProductDetailContext } from '../../containers/product/ProductDetailV2Container';
import { usePriceProps } from '../../hooks/usePriceProps';
import { productActions } from '../../redux/product/actions/ProductActions';
import { showMobileHeader } from '../../util/HtmlElementUtil';
import { getImageSourceSetByProductCode } from '../../util/ImageUtil';
import { getSizeDescription } from '../../util/ProductUtil';
import { generateTestId } from '../../util/TestUtil';
import { WishlistButton } from '../wishlist-button/WishlistButton';
import { ProductBundleAlternative } from './ProductBundleAlternative';
const TEST_ID = 'product-bundle-tile';
export const ProductBundleTileItem = ({ productSlot, isMonetateBundle }) => {
    var _a, _b, _c, _d;
    const { tileListName } = useTileListContext();
    const [miniPDPProduct, setMiniPDPProduct] = useState();
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const dispatch = useDispatch();
    const { deliveryPromiseExplanations } = useProductDetailContext();
    const { oneSizeProductCode, productImageConfig, root } = useAemConfig();
    const isTablet = useMediaQuery(`(min-width:${MIN_SCREEN_WIDTH_TABLET}px) and (max-width:${MAX_SCREEN_WIDTH_TABLET}px)`);
    const isDesktop = useMediaQueryMatchesOnDesktop();
    const product = productSlot.displayedProduct
        ? productSlot.bundleChildren.find(child => { var _a; return child.productId === ((_a = productSlot.displayedProduct) === null || _a === void 0 ? void 0 : _a.productId); })
        : productSlot.bundleChildren[0];
    const hasAlternatives = productSlot.bundleChildren.length > 1;
    const activeColour = findColor(product.colours, ((_a = productSlot.displayedProduct) === null || _a === void 0 ? void 0 : _a.colourId) || product.colourId) ||
        product.colours[0];
    const activeSize = findSizeBySku(activeColour.sizes, determineSelectedSku(activeColour, (_b = productSlot.displayedProduct) === null || _b === void 0 ? void 0 : _b.skuId));
    const priceObject = activeSize || activeColour;
    const priceInformation = {
        hasDiscount: priceObject.price.discountPercentage > 0,
        prices: priceObject.prices,
    };
    const childImage = getImageSourceSetByProductCode(product.productCode, activeColour.image, productImageConfig);
    const childPriceProps = usePriceProps({
        priceInformation,
        dynamicSavingsInformation: {
            productDiscountAmount: priceObject.price.discountAmount,
            productDiscountPercentage: priceObject.price.discountPercentage,
        },
    });
    const clickedOnShowAlternatives = () => {
        dispatch(productActions.bundleSetSelectedAlternativeTab(`bundle-alternatives-slot-${product.slotNumber}`));
    };
    const oneSizeProduct = isOneSizeProduct(activeColour.sizes, oneSizeProductCode);
    const isOneColorOneSize = product.colours.length === 1 && isOneSizeProduct(activeColour.sizes, oneSizeProductCode);
    const isSingleAvailability = activeColour.sizes.filter(size => size.active && size.availability > 0).length === 1;
    const sizeDescription = !oneSizeProduct && activeSize && getSizeDescription(activeSize);
    const productUrl = root
        .concat(product.seoUrl.indexOf('/') === 0
        ? PRODUCT_URL_PREFIX + product.seoUrl
        : PRODUCT_URL_PREFIX + '/' + product.seoUrl)
        .concat('.html')
        .concat(`?colour=${activeColour.colourId}`);
    useEffect(() => {
        if (!isOneColorOneSize && !isSingleAvailability) {
            return;
        }
        dispatch(productActions.bundleSetDisplayedProduct({
            slotNumber: productSlot.slotNumber,
            displayedProduct: {
                productCode: product.productCode,
                productId: product.productId,
                colourId: activeColour === null || activeColour === void 0 ? void 0 : activeColour.colourId,
                skuId: activeSize === null || activeSize === void 0 ? void 0 : activeSize.sku,
            },
        }));
    }, [isOneColorOneSize, isSingleAvailability]);
    const selectedBundleSlot = (state = true) => {
        dispatch(productActions.bundleSetSelectedSlotState({
            slotNumber: productSlot.slotNumber,
            state,
        }));
    };
    const handleMiniPDPClose = () => {
        setMiniPDPProduct(null);
    };
    const handleMiniPDPSubmit = (addProduct) => {
        dispatch(productActions.bundleSetDisplayedProduct({
            slotNumber: productSlot.slotNumber,
            displayedProduct: {
                productCode: addProduct.product.productCode,
                productId: addProduct.product.productId,
                colourId: addProduct.colorId,
                skuId: addProduct.sku,
            },
        }));
        if (!productSlot.isSelected) {
            selectedBundleSlot();
        }
        dispatch(productActions.bundleCalculateStart());
        setMiniPDPProduct(null);
    };
    const handleColourSizeClick = () => {
        setMiniPDPProduct(productSlot.displayedProduct || {
            productCode: product.productCode,
            colourId: product.colourId || product.colours[0].colourId,
        });
    };
    const handleSelectionChange = () => {
        var _a;
        if (!productSlot.isSelected && !((_a = productSlot.displayedProduct) === null || _a === void 0 ? void 0 : _a.skuId)) {
            handleColourSizeClick();
            return;
        }
        selectedBundleSlot(!productSlot.isSelected);
        if (productSlot.displayedProduct) {
            dispatch(productActions.bundleCalculateStart());
        }
    };
    const handleAlternativesSubmit = (addProduct) => {
        dispatch(productActions.bundleSetDisplayedProduct({
            slotNumber: productSlot.slotNumber,
            displayedProduct: addProduct,
        }));
        if (!productSlot.isSelected) {
            selectedBundleSlot();
        }
        dispatch(productActions.bundleCalculateStart());
    };
    const handleWishlistButtonClick = () => !isDesktop && showMobileHeader();
    return (_jsxs(_Fragment, { children: [_jsxs(TileListItem, { hasDivider: true, boxProps: {
                    mobile: { spacing: { marginTop: 2, marginBottom: 2 } },
                    dataAttributes: isMonetateBundle ? { 'data-monetate-product-id': `p${product.productId}` } : undefined,
                }, id: `${tileListName}-${productSlot.slotNumber}`, image: _jsx(Image, { alt: `${product.brand} - ${product.title}`, src: childImage[ProductImageSizesPortraitEnum.basket], srcset: {
                        [MAX_SCREEN_WIDTH_TABLET_SMALL]: childImage[ProductImageSizesPortraitEnum.bundles],
                        [MIN_SCREEN_WIDTH_DESKTOP_LARGE]: childImage[ProductImageSizesPortraitEnum.basket],
                    }, isPicture: true }), quickAction: _jsx(WishlistButton, { productCode: product.productCode, productId: product.productId, colourId: activeColour.colourId, skuId: activeSize === null || activeSize === void 0 ? void 0 : activeSize.sku, onToggle: handleWishlistButtonClick }), onChange: handleSelectionChange, children: [_jsxs(TileListItem.Content, { area: "primary", children: [_jsx(Box, { marginInlineEnd: "8", children: _jsx(Link, { href: productUrl, variant: "secondary", size: "sm", testId: generateTestId({ testId: TEST_ID, suffix: 'title' }), children: _jsxs(TextAlpha, { variant: "bodyS", children: [product.brand && (_jsxs(TextAlpha, { as: "span", strong: true, variant: "inherit", children: [product.brand, ' '] })), product.title] }) }) }), !!product.productRating && (_jsx(Breakpoint, { from: "md", children: _jsx(Box, { paddingBlockStart: "2", paddingBlockEnd: "4", children: _jsx(Rating, { readOnly: true, rating: (_c = product.productRating) !== null && _c !== void 0 ? _c : 0, children: _jsx(TextAlpha, { variant: "bodyXS", color: "subtle", as: "span", children: (_d = product.productReviews) !== null && _d !== void 0 ? _d : 0 }) }) }) })), !isOneColorOneSize && (_jsx(Box, { paddingBlockStart: { base: '2', md: '3' }, paddingBlockEnd: "2", children: _jsxs(PillButton, { onClick: handleColourSizeClick, variant: "secondary", size: "sm", testId: generateTestId({ testId: TEST_ID, suffix: 'color-size' }), children: [oneSizeProduct
                                            ? t('product.bundleDeals.cta.color')
                                            : product.colourId || product.colours.length === 1
                                                ? t('product.bundleDeals.cta.size')
                                                : t('product.bundleDeals.cta.colorAndSize'), _jsx(Icon, { source: CaretRightIcon, size: "sm" })] }) })), (activeColour || sizeDescription) && (_jsx(Box, { paddingBlockStart: { base: '2', md: '3' }, paddingBlockEnd: "2", children: _jsxs(TextAlpha, { color: "subtle", variant: "bodyS", testId: generateTestId({ testId: TEST_ID, suffix: 'description' }), children: [sizeDescription && `${t('pdp.size')} ${sizeDescription}`, sizeDescription && activeColour && ', ', t('pdp.color'), ": ", activeColour.description] }) }))] }), _jsx(TileListItem.Content, { area: "secondary", children: _jsxs(Stack, { flex: { grow: 1 }, direction: isTablet ? 'col' : 'row', align: isTablet ? 'start' : 'end', justify: isTablet ? 'end' : 'between', children: [!!childPriceProps && (_jsx(Box, { paddingBlockStart: { base: '3', md: '4' }, children: _jsx(Price, Object.assign({}, childPriceProps)) })), _jsx(Box, { paddingBlockStart: { base: '3', md: '2', lg: '4' }, children: hasAlternatives && (_jsx(Link, { size: "sm", onClick: clickedOnShowAlternatives, testId: generateTestId({ testId: TEST_ID, suffix: 'alternative-btn' }), children: t('product.bundleDeals.cta.alternative') })) })] }) })] }), miniPDPProduct && (_jsx(MiniPDPContainer, { productCode: miniPDPProduct.productCode, colorId: miniPDPProduct.colourId, selectedSku: miniPDPProduct.skuId ? parseInt(miniPDPProduct.skuId, 10) : undefined, deliveryPromiseExplanations: deliveryPromiseExplanations, onClose: handleMiniPDPClose, onSubmit: handleMiniPDPSubmit, submitText: t('product.bundleDeals.colorAndSize.cta.save'), miniPDPProps: {
                    productColors: product.colours.map(colour => (Object.assign(Object.assign({}, colour), { sizes: colour.sizes.map(size => {
                            var _a, _b;
                            return (Object.assign(Object.assign({}, size), { productDiscountAmount: (_a = size.price) === null || _a === void 0 ? void 0 : _a.discountAmount, productDiscountPercentage: (_b = size.price) === null || _b === void 0 ? void 0 : _b.discountPercentage }));
                        }), price: {
                            productDiscountPercentage: colour.price.discountPercentage,
                            productDiscountAmount: colour.price.discountAmount,
                            hasDiscount: colour.price.discountPercentage > 0,
                        } }))),
                } })), hasAlternatives && _jsx(ProductBundleAlternative, { productSlot: productSlot, onSubmit: handleAlternativesSubmit })] }));
};
